import { LinkButton } from '@ksb/ui';
import { useSeitenStile } from '../components/stile';

export function NichtGefundenSeite() {
  const s = useSeitenStile();
  return (
    <section className={s.kopf}>
      <h1 className="ksb-h1">Seite nicht gefunden</h1>
      <p style={{ margin: 0 }}>Diese Seite gibt es nicht.</p>
      <LinkButton to="/" size="sm" style={{ alignSelf: 'flex-start' }}>
        Zur Startseite
      </LinkButton>
    </section>
  );
}
